import React, { useEffect, useState } from 'react';
import intl from 'react-intl-universal';
import { store } from 'Store/store.index';
import { Modal } from 'antd';
import { INDIVIDUAL_BUNDLE_PRODUCT_LIST, ENTERPRISE_BUNDLE_PRODUCT_LIST, EDU_BUNDLE_PRODUCT_LIST } from './payment.constants';
import BundleProdCard from './BundleProdCard';
import './PaymentDlg.scss';

const BundlePaymentDialog = (props) => {
  const { show, close } = props;
  const EduUpgradePlan = intl.formatMessage({ id: 'account.EduUpgradePlan' });
  const NorUpgradePlan = intl.formatMessage({ id: 'account.NorUpgradePlan' });
  const UpgradeBundleTip = intl.formatMessage({ id: 'account.UpgradeBundleTip' });
  const TipUpgradeToStore = intl.getHTML('account.TipUpgradeToStore');

  const [cardList, setCardList] = useState([]);

  const { isEdu, isEnterpriseUser } = store.userStore;

  useEffect(() => {
    if (isEnterpriseUser) {
      setCardList(ENTERPRISE_BUNDLE_PRODUCT_LIST);
    } else if (isEdu) {
      setCardList(EDU_BUNDLE_PRODUCT_LIST);
    } else {
      setCardList(INDIVIDUAL_BUNDLE_PRODUCT_LIST);
    }
  }, []);

  const mountNode = domNode => {
    if (!domNode) return;
    document.querySelector('#upgradeToFoxitStore').onclick = () => {
      store.userStore.goFoxitStore();
    };
  };

  const selectCard = (index) => {
    const cardDoms = document.querySelectorAll('.bundle-card-box');
    cardDoms.forEach((dom, i) => {
      if (i === index) {
        dom.classList.add('on');
      } else {
        dom.classList.remove('on');
      }
    });
  };

  useEffect(() => {
    store.appStore.addAppEventListener('has-close-shopping-car', close);
    return () => {
      store.appStore.removeAppEventListener('has-close-shopping-car', close);
    };
  }, []);

  return (
    <Modal
      width={740}
      visible={show}
      footer={null}
      onCancel={close}
      maskClosable={false}
      wrapClassName='pay-bundle-dialog'
    >
      <div className={`main-content ${isEdu ? 'edu-b-dlg' : ''}`}>
        <h4>{isEdu ? EduUpgradePlan : NorUpgradePlan}</h4>
        <p>{UpgradeBundleTip}</p>
        <div className='bundle-prod-list'>
          {cardList.map((item, index) => (<BundleProdCard close={close} key={item.sku} isSel={index === 0} info={item} selectCard={() => selectCard(index)} />))}
        </div>
        <div className='tc' ref={mountNode}>{TipUpgradeToStore}</div>
      </div>
    </Modal>
  );
};
export default BundlePaymentDialog;